import { blockSubMerchant, detailSubMerchant, maskedDetailSubMerchant, plainDetailSubMerchant, requestLinkResetPinSubMerchant, unblockSubMerchant } from '../../utils/api';
import { actionTypes } from './constants';

export function setFailedAction({ key, message, error, data, code }) {
  return { type: actionTypes.FAILED, key, message, error, data, code };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}
export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true,
  code = 200,
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, initial, message, success, code };
}

export function reset(key) {
  return { type: actionTypes.RESET, key };
}

export const clearRedux = (key)  => {
  return async(dispatch) => {
    dispatch(reset(key));
  };
};

export const fetchDetailSubMerchant = (id, key = 'search') => {
  return async (dispatch) => {
    try{
      dispatch(setLoadingAction({ key }));
      let response = { data: null , code: 200 };
      if(key === 'plain'){
        response = await plainDetailSubMerchant(id);
      }else if(key === 'masked'){
        dispatch(clearRedux('search'));
        response = await maskedDetailSubMerchant(id);
      }else {
        response = await detailSubMerchant(id);
      }
      const { data, code } = response;
      dispatch(setSuccessAction({ key, data, code }));
    }catch(error){
      const { message, code } = error;
      dispatch(setFailedAction({ key, message , code }));
    }
  };
};

export const subMerchantAction = (payload, key = 'reset') => {
  return async (dispatch) => {
    try{
      dispatch(setLoadingAction({ key }));
      let response = { data: null , code: 200 };
      if(key === 'block'){
        response = await blockSubMerchant(payload);
      }else if(key === 'unblock'){
        response = await unblockSubMerchant(payload);
      }else {
        response = await requestLinkResetPinSubMerchant(payload);
      }
      const { data, code } = response;
      dispatch(setSuccessAction({ key, data, code }));
    }catch(error){
      const { message, code, data } = error;
      const now = new Date();
      now.setSeconds(now.getSeconds() + data?.countDownTime);
      const modData = { countDownTime: now };
      dispatch(setFailedAction({ key, message , code, data: modData }));
    }
  };
};
